import type { Invoice } from 'contracts/tracking-v2/invoices';

export const getUniqueGeolocations = ({
                                        geolocations,
                                        maxGeolocations,
                                      }: {
  geolocations: Invoice['geolocation'],
  maxGeolocations?: number
}) => {
  if (!geolocations?.length) return [];

  const positions = geolocations
    .filter(
      (geo) =>
        geo.latitude &&
        geo.longitude &&
        (Number(geo.latitude) !== 0 || Number(geo.longitude) !== 0),
    )
    .map((geo) => ({
      lat: parseFloat(geo.latitude),
      lng: parseFloat(geo.longitude),
      date: geo.geolocationDate
        ? new Date(geo.geolocationDate)
        : new Date(),
    }));

  positions.sort((a, b) => a.date.getTime() - b.date.getTime());

  const uniquePoints = positions.reduce((acc, p) => {
    const latPrefix = p.lat.toString().slice(0, 6);
    const lngPrefix = p.lng.toString().slice(0, 6);

    const last = acc[acc.length - 1];
    const lastLatPrefix = last?.lat.toString().slice(0, 6);
    const lastLngPrefix = last?.lng.toString().slice(0, 6);

    if (latPrefix !== lastLatPrefix || lngPrefix !== lastLngPrefix) {
      acc.push(p);
    }

    return acc;
  }, [] as typeof positions);

  if (maxGeolocations && uniquePoints.length > maxGeolocations) {
    const step = Math.ceil(uniquePoints.length / maxGeolocations);
    return uniquePoints
      .filter((_, idx) => idx % step === 0 || idx === uniquePoints.length - 1)
      .map(({ lat, lng }) => ({ lat, lng }));
  }

  return uniquePoints.map(({ lat, lng }) => ({ lat, lng }));
};